module.exports = __webpack_public_path__ + "img/handoffIcon_1.5c4172a7.svg";